export const setStore = (key: string, value: any): void => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    if(!value && value !== 0) value = ''
    const valueStr = JSON.stringify(value)
    window.localStorage.setItem(key, valueStr)
}

export const getStore = (key: string) : any => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    const valueStr = window.localStorage.getItem(key)
    if(valueStr) {
        return JSON.parse(valueStr)
    } else {
        return ''
    }
}

export const removeStore = (key: string) => {
    key = key.trim()
    if(!key) {
        throw new Error('key is empty')
    }
    window.localStorage.removeItem(key)
}


export const setOrderStore = (showInfo: any) => {
    const orderCatchList = getOrderStore()
    const hash = showInfo.hash.toLowerCase()
    const index = orderCatchList.findIndex((item: any) => item.hash.toLowerCase() === hash)
    if(index > -1) {
        orderCatchList[index] = showInfo
    } else {
        orderCatchList.push(showInfo)
    }
    setStore('chainge.orderList', orderCatchList)
}

export const getOrderStore = () => {
    const orderCatchList = getStore('chainge.orderList')
    return orderCatchList || []
}

export const removeOrderStore = (id: string) => {
    const orderCatchList = getOrderStore()
    const index = orderCatchList.findIndex((item: any) => item.id === id)
    if(index > -1) {
        orderCatchList.splice(index, 1)
        setStore('chainge.orderList', orderCatchList)
    }
}

// 获得当前钱包名称
export const getCurConnectWalletFlag = () => {
    return getStore('chainge.curWallet') || ''
}